var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconoWalmartMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.448,
    height: 32.138,
    viewBox: "0 0 31.448 32.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541",
    transform: "translate(-102.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M202.149,10.819a1.388,1.388,0,0,0,1.462-.894l.743-8.411c0-.833-.981-1.515-2.2-1.515s-2.2.682-2.2,1.515l.749,8.411a1.376,1.376,0,0,0,1.456.894",
    transform: "translate(-85.209)",
    fill: "#ffb300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M188.571,18.459a1.379,1.379,0,0,0-.051-1.712L181.587,11.9c-.721-.421-1.8.081-2.418,1.142s-.491,2.249.215,2.661l7.675,3.558a1.372,1.372,0,0,0,1.511-.808",
    transform: "translate(-76.186 -5.008)",
    fill: "#ffb300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M211.535,18.454a1.411,1.411,0,0,0,1.513.818l7.675-3.568c.713-.421.82-1.6.217-2.658s-1.7-1.559-2.421-1.147l-6.934,4.843a1.415,1.415,0,0,0-.041,1.718",
    transform: "translate(-90.039 -5.009)",
    fill: "#ffb300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M202.149,37.163a1.388,1.388,0,0,1,1.462.894l.743,8.411c0,.833-.981,1.508-2.2,1.508s-2.2-.675-2.2-1.508l.749-8.411a1.376,1.376,0,0,1,1.456-.894",
    transform: "translate(-85.209 -15.837)",
    fill: "#ffb300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M211.535,31.949c.393-.652,1.035-1,1.513-.812l7.675,3.562c.713.412.82,1.6.217,2.661s-1.7,1.554-2.421,1.142l-6.934-4.849a1.394,1.394,0,0,1-.041-1.7",
    transform: "translate(-90.039 -13.248)",
    fill: "#ffb300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M188.571,31.941a1.38,1.38,0,0,1-.051,1.712l-6.933,4.841c-.721.421-1.8-.082-2.418-1.135s-.491-2.249.215-2.661l7.675-3.562a1.37,1.37,0,0,1,1.511.8",
    transform: "translate(-76.186 -13.247)",
    fill: "#ffb300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M231.041,41.939h.1c.13,0,.182.041.2.145a.713.713,0,0,0,.071.225h.246a.448.448,0,0,1-.064-.232.262.262,0,0,0-.182-.22v-.023a.224.224,0,0,0,.2-.215.284.284,0,0,0-.085-.2.669.669,0,0,0-.335-.071,1.553,1.553,0,0,0-.358.035v.93h.218Zm.007-.424.112-.015c.131,0,.2.061.2.146s-.1.14-.217.14h-.1Zm.14-.631a.943.943,0,1,0,.959.936.939.939,0,0,0-.959-.936m0,.189a.751.751,0,0,1,0,1.5.751.751,0,0,1-.007-1.5",
    transform: "translate(-98.111 -17.424)",
    fill: "#ffb300"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoWalmartMobile);
export default __webpack_public_path__ + "static/media/icono-walmart-mobile.6ba451da68cc0af68134127439600c24.svg";
export { ForwardRef as ReactComponent };